import {
  analyticsReduxRegistry,
  DATA_LAYER_SCOPES,
  withWaitForFetch
} from "seneca-common/features/analytics";
import { getCourseName as getCourseNameCoursesQuery } from "seneca-common/features/course-discovery/courses-query/state";
import { getCourseName as getCourseNameAllCourses } from "seneca-common/features/course/state";
import {
  analyticsCategories,
  AnalyticsEventsRegister,
  makeAnalyticsEvent
} from "seneca-common/utils/senecaAnalytics";
import { logMessage } from "seneca-common/utils/sentry/logError";

import {
  getFetchCourseEnrollmentsFinished,
  getNumberOfEnrolledCourses
} from "../state";
import actionTypes from "../state/action-types";

// this analytics event is triggered by redux enrollments which can happen in multiple locations in the app
// depending on the users location we have different parts of courses state populated so need to check all
// if no course name exists to populate the coursename field
const getCourseName = (state: any, courseId: string) => {
  let courseName = getCourseNameCoursesQuery(state, courseId);

  if (!courseName) {
    courseName = getCourseNameAllCourses(state, courseId);
  }

  if (!courseName) {
    logMessage("unable to get courseName for analytics", {
      extraInfo: {
        courseId
      }
    });
  }

  return courseName;
};

const makeSaveCourseEnrollmentAnalyticsEvent = (action: any, state: any) => {
  const { courseId } = action.payload.enrollment;
  const courseName = getCourseName(state, courseId);

  const payload = {
    courseName
  };
  return makeAnalyticsEvent(analyticsCategories.COURSE_ENROLLMENT, payload);
};

const makeDeleteCourseEnrollmentAnalyticsEvent = (action: any, state: any) => {
  const { courseId } = action.payload;
  const courseName = getCourseName(state, courseId);

  const payload = {
    courseName
  };
  return makeAnalyticsEvent(analyticsCategories.COURSE_ENROLLMENT, payload);
};

AnalyticsEventsRegister.addEventGenerators({
  [actionTypes.SAVE_NEW_COURSE_ENROLLMENT]:
    makeSaveCourseEnrollmentAnalyticsEvent,
  [actionTypes.DELETE_COURSE_ENROLLMENT]:
    makeDeleteCourseEnrollmentAnalyticsEvent
});

analyticsReduxRegistry.registerGlobalSelectorsToDataLayerScope(
  DATA_LAYER_SCOPES.STUDENT_STATS,
  {
    numberOfCoursesEnrolled: withWaitForFetch(
      getNumberOfEnrolledCourses,
      getFetchCourseEnrollmentsFinished
    )
  }
);

analyticsReduxRegistry.registerEventGenerator({
  triggerReduxActionType: actionTypes.SAVE_NEW_COURSE_ENROLLMENT,
  gtmEventName: "seneca/studentCourse/enrol"
});
